import React, { useEffect } from 'react';
import { Button, Form, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useUpdatePublisherInvoiceMutation } from '../../../../api/publisherInvoiceApiSlice';
import { FormGroup, useForm, Yup } from '../../../components';
import { BillingInput } from '../billing_form/BillingInput';

const PublisherEditInvoiceModal = ({show, setShow, data}) => {
  const { t } = useTranslation();
  const [update] = useUpdatePublisherInvoiceMutation();
  const initialValues = { modified_users: (data.modified_users || ''), modified_mrg_pricing: (data.modified_mrg_pricing || {}) }
  const validationSchema = Yup.object().shape({
    modified_users: Yup.number().allowEmptyString(),
    modified_mrg_pricing: Yup.object(),
  })
  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
  });
  const onSubmit = () => {
    update({
      ...formData,
      publisherId: data.publisher_id,
      year: data.year,
      month: data.month
    }).then(()=>{setShow(false)})
  }
  useEffect(() => {
    const {modified_users, modified_mrg_pricing} = data
    setFormData({modified_users, modified_mrg_pricing})
  }, [data])

  return (
    <Modal show={show} onHide={()=>(setShow(false))}>
      <Modal.Header closeButton>
        <Modal.Title>{t("edit")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <FormGroup
            label={t("publisherInvoice.users")}
            input="number"
            {...getInputProps("modified_users")}/>
          <BillingInput
            value={getInputProps("modified_mrg_pricing").value}
            onChange={getInputProps("modified_mrg_pricing").onChange}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={()=>(setShow(false))}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          {t("save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PublisherEditInvoiceModal;